import moment from 'moment';

export default function genererCritereRecherche() {
  const dateJour = new Date();
  let dateDebutSouhaite = new Date(dateJour.getFullYear(), dateJour.getMonth(), 1);
  dateDebutSouhaite = moment(moment(dateDebutSouhaite).subtract(2, 'years')).toDate();
  return {
    codes: [],
    typesOt: [],
    otEtat: [],
    dates: {
      dateDebut: dateDebutSouhaite,
      dateFin: null,
    },
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    datesValidite: {
      dateDebut: null,
      dateFin: null,
    },
    datesFacture: {
      dateDebut: null,
      dateFin: null,
    },
    tiersId: [],
    tiers: [],
    sansDatePremierAffichage: false,
    projetsId: [],
    projets: [],
    dossiersId: [],
    dossiers: [],
    faceIds: [],
    villes: [],
    patrimoineIds: [],
    codesFacture: [],
    sansAudit: true,
    facture: null,
    agencesId: [],
  };
}
